export const SLR_POSTED_LOADING_START = 'SLR_POSTED_LOADING_START';
export const SLR_POSTED_LOADING_END = 'SLR_POSTED_LOADING_END';
export const SLR_CONTRACT_START = 'SLR_CONTRACT_START';
export const SLR_CONTRACT_END = 'SLR_CONTRACT_END';
export const SLR_CONTRACT_BY_ID = 'SLR_CONTRACT_BY_ID';
export const SLR_CONTRACT_RESET = 'SLR_CONTRACT_RESET';
export const SLR_POSTED_RESULTS_SUCCESS = 'SLR_POSTED_RESULTS_SUCCESS';
